<script>
  import { onMount } from "svelte";
  import { flip } from "svelte/animate";
  import { quintOut } from "svelte/easing";
  import { API_URL } from "./Var.svelte";

  let queue = [];
  let cookies = [];

  const api_host = API_URL;

  let updateCookies = () => {
    let output = {};
    document.cookie.split(/\s*;\s*/).forEach(function (pair) {
      pair = pair.split(/\s*=\s*/);
      output[pair[0]] = pair.splice(1).join("=");
    });
    cookies = output;
  };

  const handleSongClicked = (uri, ticks) => {
    updateCookies();
    if (cookies.hasOwnProperty(uri+ticks)) {
      console.log("already upvoted");
    } else {
      const found = queue.find((e) => e.trackURI == uri);
      found.up += ticks;
      let oldQ = queue.filter((e) => e.trackURI != uri);
      upVote(uri, ticks);
      queue = [found, ...oldQ].sort((y, x) => x.up - y.up);
      setCookie(uri+ticks);
    }
  };

  let setCookie = (uri) => {
    var now = new Date();
    var time = now.getTime();
    time += 600 * 1000;
    now.setTime(time);
    document.cookie =
      uri + "=" + true + "; expires=" + now.toUTCString() + "; path=/";
  };

  async function fetchData() {
    let url = `${api_host}/queue`;
    const response = await fetch(url);
    let temp = await response.json();
    queue = temp.sort((y, x) => x.up - y.up);
  }

  async function upVote(uri, ticks) {
    let url = `${api_host}/vote?track=${uri}&ticks=${ticks}`;
    const response = await fetch(url);
    let res = await response.json();
  }

  onMount(() => {
    const interval = setInterval(fetchData, 5000);
    fetchData();

    return () => clearInterval(interval);
  });
</script>

<div class="songs">
  <h4>Vote for songs!</h4>
  {#if queue.length === 0}
    <p>Queue is empty</p>
  {:else}
    {#each queue as song (song.trackURI)}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="song"
        animate:flip={{ delay: 250, duration: 500, easing: quintOut }}
      >
        <img
          src={song.track.album.images[0].url}
          alt="Album {song.track.album.name}"
        />
        <div class="nameup">
          <span class="songname"
            >{song.track.name}<br />{song.track.artists[0].name}</span
          >
          <span>{song.up}</span>
          <div class="upvotes">
            <div on:click={() => handleSongClicked(song.trackURI, 1)} class="up">
                <img src="up.png" alt="">
            </div>
            <div on:click={() => handleSongClicked(song.trackURI, -1)} class="up">
                <img src="down.png" alt="">
            </div>
          </div>
        </div>
      </div>
    {/each}
  {/if}
</div>

<style>
  .upvotes {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    height: 100%;
    box-sizing: border-box;
  }

  .up {
    /* background-color: #1db954; */
    display: flex;
    flex-direction: row;
    justify-content: center;
    box-sizing: border-box;
    margin: 6px 0 6px 0;
  }

  .upvotes img {
    width: 25px;
    filter: invert();
  }

  .down {
    /* background-color: #f7283c; */
  }

  .songs {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
  }

  /* .song:nth-child(2) {
    background: #1db954;
  } */

  .song {
    height: 80px;
    background-color: #191414;
    color: aliceblue;
    margin: 10px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    box-shadow: 3px 3px 10px #888888;
    overflow: hidden;
    line-height: 1.1em;
    box-sizing: border-box;
  }

  .nameup {
    display: grid;
    width: 100%;
    grid-template-columns: 4fr 1fr 1fr;
    align-items: center;
    padding: 0;
    height: 100%;
  }

  .songname {
    padding-left: 2em;
    line-height: 1.2em;
    overflow: hidden;
  }

  .song img {
    height: 100%;
  }
</style>
